import { SIPackageId } from "app/common/after-trial/packageIds";
import { DEFAULT_HOMEPAGES } from "app/components/modals/constants";
import { getPurchasePageHref } from "app/UtilitiesAndConstants/UtilityFunctions/goToPurchasePage";

import type { AppsSolutionStoreType, FactoryDeps, ISolutionUrlsProvider } from "./types";

export const createSolutionUrlsService = ({ settingsProvider }: FactoryDeps): ISolutionUrlsProvider => {
    // App Intelligence
    const getAppAnalysisUrl = (appId: string, store: AppsSolutionStoreType): string =>
        `${settingsProvider.swsites.apps}/app-analysis/overview/${store}/${appId}`;

    // Account
    const getAccountUrl = (path: string, returnUrl: string = location.href): string => {
        const url = `${settingsProvider.swsites.login}/${path}`;

        return `${url}?returnToProUrl=${encodeURIComponent(returnUrl)}`;
    };

    const getAccountManagementUrl = (returnUrl?: string): string => getAccountUrl("user-management", returnUrl);

    const getAccountDataCreditsUrl = (returnUrl?: string): string => getAccountUrl("si-credits", returnUrl);

    const getStandardApiUrl = (): string => `${settingsProvider.swsites.login}/standard-api`;

    const getTrialUpgradeUrl = (): string =>
        getPurchasePageHref({
            package: SIPackageId,
            period: "annually",
            workspace: DEFAULT_HOMEPAGES.SI,
        });

    const getSiUpgradePurchaseUrl = (billingPeriod: string): string =>
        getPurchasePageHref({
            workspace: DEFAULT_HOMEPAGES.SI,
            package: SIPackageId,
            period: billingPeriod,
        });

    return {
        getAppAnalysisUrl,
        getAccountUrl,
        getAccountManagementUrl,
        getAccountDataCreditsUrl,
        getStandardApiUrl,
        getTrialUpgradeUrl,
        getSiUpgradePurchaseUrl,
    };
};
